document.addEventListener('DOMContentLoaded', function() {
    var productGrids = document.querySelectorAll('.grid.product-grid');

    productGrids.forEach(function(productGrid) {
        var sectionId = productGrid.getAttribute('data-section-id');
        var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
        
        productGrid.addEventListener('change', function(e) {
            if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"]')) {

                var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
                var variantId = e.target.getAttribute('data-variant-id');
                var variantData = variantDataMap[variantId];

                if (!variantData) {
                    console.log('No data found for variant:', variantId);
                    return;
                }

                // update product image with variant's full image
                var productImageElement = card.querySelector('.card__media img');
                if (productImageElement) {
                    var masterImageUrl = variantData.imageUrl; // <-- zamiast data-image-url

                    if (masterImageUrl) {
                        var dynamicSrcset = [
                            masterImageUrl + ' 165w',
                            masterImageUrl + ' 360w',
                            masterImageUrl + ' 533w',
                            masterImageUrl + ' 720w',
                            masterImageUrl + ' 940w',
                            masterImageUrl + ' 1066w',
                            masterImageUrl + ' 1500w',
                            masterImageUrl + ' 3000w'
                        ].join(', ');

                        productImageElement.srcset = dynamicSrcset;
                        productImageElement.src = masterImageUrl;
                    } else {
                        console.log('No variant imageUrl found for variant:', variantId);
                    }
                } else {
                    console.log('No product image element found in this card.');
                }

                // Update the product URL
                var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
                productLinks.forEach(function(link) {
                    link.href = variantData.productUrl;
                });

            } else {
                console.log('Change detected, but not on a swatch.');
            }
        });
    });
});
